import { ContactAvatar, Subcontact } from '@cian/contact-card-component';
import * as React from 'react';

interface IAgentDescription {
  agentLink: string | null;
  agentName: string;
  agentReviews: React.ReactNode;
  agentAvatar: string | null;
  onAgentNameClick(): void;
}

const AgentDescriptionComponent: React.FC<IAgentDescription> = ({
  agentLink,
  agentName,
  agentReviews,
  agentAvatar,
  onAgentNameClick,
}) => {
  return (
    <Subcontact
      title="Риелтор"
      onNameClick={onAgentNameClick}
      href={agentLink}
      name={agentName}
      labels={agentReviews}
      avatar={<ContactAvatar type="agent" src={agentAvatar} />}
    />
  );
};

export const AgentDescription = React.memo(AgentDescriptionComponent);
